module.exports = __webpack_public_path__ + "img/painting-app_cn.829c49c.jpg";